import React from "react";

const Bad = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <path
        d="M38.5 77C59.763 77 77 59.763 77 38.5C77 17.237 59.763 0 38.5 0C17.237 0 0 17.237 0 38.5C0 59.763 17.237 77 38.5 77Z"
        fill="#FBC926"
      />
      <path
        d="M34 72.6984C24.9 72.6984 16.6 69.4984 10 64.2984C17 72.0984 27.2 76.9984 38.5 76.9984C59.8 76.9984 77 59.7984 77 38.4984C77 26.2984 71.3 15.4984 62.5 8.39844C68.7 15.1984 72.5 24.2984 72.5 34.1984C72.5 55.4984 55.2 72.6984 34 72.6984Z"
        fill="#F4BF11"
      />
      <path
        d="M27.4004 30.5016C26.7004 30.5016 26.1004 30.2016 25.6004 29.7016C25.5004 29.6016 25.4004 29.5016 25.3004 29.3016C25.2004 29.2016 25.1004 29.0016 25.1004 28.9016C25.0004 28.7016 25.0004 28.6016 25.0004 28.4016C25.0004 28.2016 24.9004 28.1016 24.9004 27.9016C24.9004 27.2016 25.2004 26.6016 25.7004 26.1016C26.6004 25.1016 28.4004 25.1016 29.3004 26.1016C29.8004 26.6016 30.1004 27.2016 30.1004 27.9016C30.1004 28.1016 30.1004 28.2016 30.0004 28.4016C30.0004 28.6016 29.9004 28.7016 29.9004 28.9016C29.8004 29.1016 29.8004 29.2016 29.7004 29.3016C29.6004 29.4016 29.5004 29.6016 29.4004 29.7016C28.7004 30.2016 28.1004 30.5016 27.4004 30.5016Z"
        fill="#332F2E"
      />
      <path
        d="M49.5996 30.4969C48.8996 30.4969 48.2996 30.1969 47.7996 29.6969C47.6996 29.5969 47.5996 29.4969 47.4996 29.2969C47.3996 29.1969 47.2996 28.9969 47.2996 28.8969C47.1996 28.6969 47.1996 28.5969 47.1996 28.3969C47.1996 28.1969 47.0996 28.0969 47.0996 27.8969C47.0996 27.6969 47.0996 27.5969 47.1996 27.3969C47.1996 27.1969 47.2996 27.0969 47.2996 26.8969C47.3996 26.6969 47.3996 26.5969 47.4996 26.4969C47.5996 26.3969 47.6996 26.1969 47.7996 26.0969C47.8996 25.9969 47.9996 25.8969 48.1996 25.7969C48.2996 25.6969 48.4996 25.5969 48.5996 25.5969C48.7996 25.4969 48.8996 25.4969 49.0996 25.4969C49.3996 25.3969 49.7996 25.3969 50.0996 25.4969C50.2996 25.4969 50.3996 25.5969 50.5996 25.5969C50.7996 25.6969 50.8996 25.6969 50.9996 25.7969C51.0996 25.8969 51.2996 25.9969 51.3996 26.0969C51.4996 26.1969 51.5996 26.2969 51.6996 26.4969C51.7996 26.5969 51.8996 26.7969 51.8996 26.8969C51.9996 27.0969 51.9996 27.1969 51.9996 27.3969C51.9996 27.5969 52.0996 27.6969 52.0996 27.8969C52.0996 28.0969 52.0996 28.1969 51.9996 28.3969C51.9996 28.5969 51.8996 28.6969 51.8996 28.8969C51.7996 29.0969 51.7996 29.1969 51.6996 29.2969C51.5996 29.3969 51.4996 29.5969 51.3996 29.6969C50.8996 30.1969 50.2996 30.4969 49.5996 30.4969Z"
        fill="#332F2E"
      />
      <path
        d="M49 51.6C48.3 51.6 47.7 51 47.7 50.3C47.7 45.2 43.5 41 38.4 41C33.3 41 29.1 45.2 29.1 50.3C29.1 51 28.5 51.6 27.8 51.6C27.1 51.6 26.5 51 26.5 50.3C26.5 43.8 31.8 38.5 38.3 38.5C44.8 38.5 50.1 43.8 50.1 50.3C50.3 51 49.8 51.6 49 51.6Z"
        fill="#332F2E"
      />
    </svg>
  );
};

export default Bad;
